<template>
    <div
        class="normal-image"
        ref="container"
        @mousemove="onMove"
        @mouseout="showZoomImage = false"
    >
        <v-img
            lazy
            ref="image"
            :aspect-ratio="$vuetify.breakpoint.smAndDown ? '3/4' : '1/1'"
            :src="image"
            :data-zoom="image"
            contain
            class="normal-image"
        ></v-img>

        <img
            :src="image"
            alt=""
            class="zoom-image"
            v-show="showZoomImage"
            ref="zoomImage"
            :style="zoomImageStyle"
        >
    </div>
</template>

<style scoped>
    .normal-image {
        height: 100%;
    }

    .zoom-image {
        position: absolute;
    }
</style>

<script>
    export default {
        data() {
            return {
                id: null,
                showZoomImage: true,
                zoomImageStyle: {
                    top: 0,
                    left: 0,
                    opacity: 0,
                },
            };
        },
        props: {
            image: {
                type: String,
            },
        },
        methods: {
            onMove(event) {
                this.showZoomImage = true;

                let imageW = this.$refs.image.$el.offsetWidth;
                let imageH = this.$refs.image.$el.offsetHeight;
                let zoomImageW = this.$refs.zoomImage.offsetWidth;
                let zoomImageH = this.$refs.zoomImage.offsetHeight;

                if (imageW > zoomImageW && imageH > zoomImageH) {
                    return;
                }

                if (imageW > zoomImageW) {
                    this.zoomImageStyle.width = imageW + 'px';
                    zoomImageW = imageW;
                } else if (imageH > zoomImageH) {
                    this.zoomImageStyle.height = imageH + 'px';
                    zoomImageH = imageH;
                }

                let mouseOffsetX = event.pageX;
                let mouseOffsetY = event.pageY;

                let rect = this.$refs.image.$el.getBoundingClientRect();
                let elementOffsetX = mouseOffsetX - rect.left;
                let elementOffsetY = mouseOffsetY - rect.top;

                let zoomImageOffsetX = -(elementOffsetX * zoomImageW / imageW) + imageW / 2;
                let zoomImageOffsetY = -(elementOffsetY * zoomImageH / imageH) + imageH / 2;

                let minOffsetX = imageW - zoomImageW;
                let minOffsetY = imageH - zoomImageH;

                zoomImageOffsetX = zoomImageOffsetX < 0 ? (zoomImageOffsetX > minOffsetX ? zoomImageOffsetX : minOffsetX) : 0;
                zoomImageOffsetY = zoomImageOffsetY < 0 ? (zoomImageOffsetY > minOffsetY ? zoomImageOffsetY : minOffsetY) : 0;

                this.zoomImageStyle.left = zoomImageOffsetX + 'px';
                this.zoomImageStyle.top = zoomImageOffsetY + 'px';
                this.zoomImageStyle.opacity = 1;
            },
        },
        watch: {
            showZoomImage(value) {
                if (!value) {
                    this.zoomImageStyle.opacity = 0;
                }
            },
        },
    };
</script>